import { render } from "./BannerSpecs.vue?vue&type=template&id=ca40aa18"
import script from "./BannerSpecs.vue?vue&type=script&lang=js"
export * from "./BannerSpecs.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__